import React from 'react';
import $S from 'theme/settings';
import DesktopView from 'plugins/tfs/pages/oms/PackageOrderList/desktopView';
import MobileView from 'plugins/tfs/pages/oms/PackageOrderList/mobileView';
import './style.css';
import { setActiveStatus } from 'actions/packageOrderList';
import { useDispatch } from 'react-redux';

// pageContainer
import PackageOrderList from '_pageContainers/oms/PackageOrderList/main';

const PackageOrderListGrid = (pageContext) => {
  const dispatch = useDispatch();

  const {
    props: {
      pending,
      history,
      activeStatusId,
      packageOrders,
      packageOrderCount,
      deliveryRanges,
      pendings,
    },
    getStatuses,
    filterPackageOrders,
  } = pageContext;

  return (
    <div className='container-fluid package-order-list headerMargin'>
      {$S.isPackageOrderListMobileView ? (
        (() => {
          return pending ? null : (
            <MobileView
              className='ant-col-xs-24'
              history={history}
              dispatch={dispatch}
              pendings={pendings}
              filterPackageOrders={filterPackageOrders}
              activeStatusId={activeStatusId}
              packageOrders={packageOrders}
              packageOrderCount={packageOrderCount}
              deliveryRanges={deliveryRanges}
              statuses={getStatuses()}
            />
          );
        })()
      ) : (
        <DesktopView
          pendings={pendings}
          activeStatusId={activeStatusId}
          packageOrders={packageOrders}
          statuses={getStatuses()}
          setActiveStatus={(id) => dispatch(setActiveStatus(id))}
        />
      )}
    </div>
  );
};

export default PackageOrderList(PackageOrderListGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderList/main/index.js